import { Fragment } from 'react';

import { CampaignSource } from 'utils/constants/campaign';

import { HoverTip } from 'bloko/blocks/drop';
import HSpacing from 'bloko/blocks/hSpacing';
import Icon, { IconColor, IconScale, IconView } from 'bloko/blocks/icon';

import useTrls from 'hooks/translation/useTrls';

import TableHead from 'components/Table/TableHead';
import TableHeadCell, { TableHeadCellKind } from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { selectIsAveragePricePerClickAvailable } from 'store/models/statistics';
import { useSelector } from 'store/utils';

import 'components/Statistic/Header/Header.less';

const Header = () => {
    const { showCr, showResponsesAndCr, headers, usedSubSources } = useSelector((state) => state.statistics);
    const isAveragePricePerClickAvailable = useSelector(selectIsAveragePricePerClickAvailable);
    const trl = useTrls();

    const vkAdsSubSources = usedSubSources ? usedSubSources[CampaignSource.VKAds] : [];

    const vkAdsTipContent = () => (
        <div className="source-click-header-tip">
            <span>{trl('Statistic.Header.tip.title')}</span>
            <ul className="source-click-header-tip-ul">
                {vkAdsSubSources?.map((subSource, key) => (
                    <li key={key}>{trl(`banner.actions.social.source.${subSource}`)}</li>
                ))}
            </ul>
        </div>
    );

    return (
        <TableHead>
            <TableRow>
                <TableHeadCell dataQa={'th_date'}>{trl('statistic.Filter.Header.lvl1.date')}</TableHeadCell>
                <TableHeadCell kind={TableHeadCellKind.Amount} dataQa={'th_shows'}>
                    {trl('statistic.Filter.Header.lvl1.shows')}
                </TableHeadCell>
                <TableHeadCell kind={TableHeadCellKind.Amount} dataQa={'th_clicks'}>
                    {trl('statistic.Filter.Header.lvl1.clicks')}
                </TableHeadCell>
                <TableHeadCell colSpan={headers?.length || 0} />
                <TableHeadCell kind={TableHeadCellKind.Amount} dataQa={'th_ctr'}>
                    {trl('statistic.Filter.Header.lvl1.ctr')}
                </TableHeadCell>
                {showResponsesAndCr && (
                    <Fragment>
                        <TableHeadCell kind={TableHeadCellKind.Amount} dataQa={'th_responses'}>
                            {trl('statistic.Filter.Header.lvl1.responses')}
                        </TableHeadCell>
                        {showCr && (
                            <TableHeadCell kind={TableHeadCellKind.Amount}>
                                {trl('statistic.Filter.Header.lvl1.cr')}
                            </TableHeadCell>
                        )}
                    </Fragment>
                )}
                {isAveragePricePerClickAvailable && (
                    <TableHeadCell kind={TableHeadCellKind.Amount} dataQa={'th_avg_price_per_click'}>
                        {trl('statistic.Filter.Header.lvl1.avgPricePerClick')}
                        <HSpacing base={1} />
                        <HoverTip
                            placement="top"
                            render={() => (
                                <div className="avgerage-price-tip">{trl('Statistic.Header.avgPricePerClick.tip')}</div>
                            )}
                        >
                            <Icon view={IconView.Info} initial={IconColor.Gray40} scale={IconScale.Small} />
                        </HoverTip>
                    </TableHeadCell>
                )}
                <TableHeadCell kind={TableHeadCellKind.Amount} dataQa={'th_charges'}>
                    {trl('statistic.Filter.Header.lvl1.charges')}
                </TableHeadCell>
            </TableRow>
            <TableRow>
                <TableHeadCell colSpan={2} />
                <TableHeadCell kind={TableHeadCellKind.Amount}>{trl('statistic.Filter.Header.lvl2.all')}</TableHeadCell>
                {headers.map((source) => (
                    <TableHeadCell key={source} kind={TableHeadCellKind.Amount}>
                        <span className="source-click-header">{trl(`banner.actions.social.source.${source}`)}</span>
                        {source === CampaignSource.VKAds && vkAdsSubSources.length > 0 && (
                            <>
                                <HSpacing base={1} />
                                <HoverTip placement="top" render={vkAdsTipContent}>
                                    <Icon view={IconView.Info} initial={IconColor.Gray40} scale={IconScale.Small} />
                                </HoverTip>
                            </>
                        )}
                    </TableHeadCell>
                ))}
                {showResponsesAndCr && <TableHeadCell colSpan={showCr ? 5 : 3} />}
                {!showResponsesAndCr && <TableHeadCell colSpan={3} />}
            </TableRow>
        </TableHead>
    );
};

export default Header;
